<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import { inject, onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
import moment from 'moment';
import { formatDateFrench } from '@/utils';

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const startupinfos: any = route.meta.startup_datas;
    const user: any = startupinfos.user;
    const loading = ref(false); const errorMessage = ref('');
    const loadingListing = ref(false); const errorMessageListing = ref('');
    const queryParams = reactive({
        pageNumber: 1,
        borneInf: '',
        borneSup: '',
        search: '',
        banque_id: null as any,
    });
    const dateParams = reactive({
        dateInf: '',
        heureInf: '',
        dateSup: '',
        heureSup: '',
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const itemsList = ref([] as any[]);

    onMounted(() => {
        doListTransactions();
    });

    async function doListTransactions() {
        try {
            loadingListing.value = true;
            errorMessageListing.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/users/${user.id}/utilisation/list_transactions?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
        } catch (error: any) {
            errorMessageListing.value = error.message;
        } finally {
            loadingListing.value = false;
        }
    }

    function onDateParamsChanged() {
        let borneInf: any = null;
        if (dateParams.dateInf) {
            borneInf = dateParams.dateInf;
            if (dateParams.heureInf) { borneInf += `T${dateParams.heureInf}`; }
            const borneInfMoment = moment(borneInf);
            if (borneInfMoment.isValid()) {
                queryParams.borneInf = borneInfMoment.format('YYYY-MM-DD HH:mm');
            }
        }

        let borneSup: any = null;
        if (dateParams.dateSup) {
            borneSup = dateParams.dateSup;
            if (dateParams.heureSup) { borneSup += `T${dateParams.heureSup}`; }
            const borneSupMoment = moment(borneSup);
            if (borneSupMoment.isValid()) {
                queryParams.borneSup = borneSupMoment.format('YYYY-MM-DD HH:mm');
            }
        }
        
        doListTransactions();
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListTransactions();
    }

    function onSelectBanque(banque_id: number) {
        queryParams.banque_id = banque_id;
        doListTransactions();
    }
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Membre / Utilisation <span class="text-sm text-grey-500"></span></h4>
        <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <span class="btn shadow-200 white2">Wallet / Utilisation</span>
            <span class="btn shadow-200 light2 border-none">Transactions</span>
        </div>

        <!--User info - Component-->
        <div class="s20 widget flex align-items-center px-1 py-5">
            <div class="s2_mobile h-100p px-7">
                <div class="rounded-100 overflow-hidden item active"><!--active-->
                    <img :src="!!user.photo_url ? user.photo_url : '/assets/users_avatar/600w/user.jpg'" width="100%" />
                </div>
            </div>
            <div class="s4_mobile h-100p px-2">
                <h3 class="mb-2">C788PMKJ</h3>
                <h4>{{ user.nom + ' ' + user.prenom }}</h4>
            </div>
            <div class="s3_mobile h-100p px-2">
                <h4 class="font-normal mb-5">{{ user.collectivite?.nom }}</h4>
                <span class="tag-state warning stroke">En cours</span>
                <span class="tag-state notif stroke">Actif</span>
            </div>
            <div class="s4_mobile h-100p px-3">
                <h4 class="font-normal">
                    Date de fin de souscription <br class="mb-2"/>
                    <b class="text-2xl">{{ user.souscription ? formatDateFrench(user.souscription.date_fin) : '-' }}</b>
                </h4>
            </div>
            <div class="s7_mobile h-100p px-5">
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">Utilisation</div>
                    <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" style="width: 25%;">
                        25%
                    </div>
                </div>
                <!--End Barre de progression-->
            </div>
        </div>
        <!--End User info-->

        <div class="clear-both h-20"></div>


        <!--Transactions - Component-->
        <div class="s20 widget px-6 pt-8 pb-2">
            <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Wallet / Utilisation
                </span>
            </div>
            <div class="s10 mt--5-5 flex-right">
                <!-- <button class="btn lg py-3 white2 active">
                    <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                    <span>Utilisation</span>
                </button> -->
            </div>

            <div class="s20 gap-6 px-5 pb-8 collapse-content active">
                <div class="clear-both h-10"></div>
                <div class="flex items-center gap-6">
                    <div class="s7">
                        <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                            <div class="circle-medium bg-color-1000"></div>
                            Solde
                        </h5>
                        <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">184 350 F</h1>
                        <h5 class="secondary-font font-semibold text-grey-700 mb-4">92%</h5>
                        <!--Barre de progression - Component-->
                        <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                            <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" style="width: 92%;">
                                92%
                            </div>
                        </div>
                        <!--End Barre de progression-->
                    </div>
                    <div class="s7">
                        <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                            <div class="circle-medium bg-purple"></div>
                            Montant Utilisé
                        </h5>
                        <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">52 350 F</h1>
                        <h5 class="secondary-font font-semibold text-grey-700 mb-4">56.4%</h5>
                        <!--Barre de progression - Component-->
                        <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                            <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white" style="width: 56.4%;">
                                56.4%
                            </div>
                        </div>
                        <!--End Barre de progression-->
                    </div>
                    <div class="s6">
                        <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                            <div class="circle-medium bg-green-light"></div>
                            Dernier décaissement
                        </h5>
                        <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">184 350 F</h1>
                        <h5 class="secondary-font font-semibold text-grey-700 mb-4">100%</h5>
                        <!--Barre de progression - Component-->
                        <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                            <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light" style="width: 100%;">
                                100%
                            </div>
                        </div>
                        <!--End Barre de progression-->
                    </div>
                </div>
                
            </div>

        </div>

        <div class="clear-both h-5"></div>
        <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
        <div class="clear-both h-5"></div>


        <div class="s20 widget px-6 pt-8 pb-2">
            <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Transactions
                </span>
            </div>
            <div class="s10 mt--5-5 flex-right">
                <!-- <button class="btn lg py-3 white2 active">
                    <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                    <span>Utilisation</span>
                </button> -->
                <button class="btn lg py-3 black">
                    <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                    <span>Exporter en PDF</span>
                </button>
                <button class="btn lg py-3 black ">
                    <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                    <span>Exporter en Excel</span>
                </button>
            </div>
            <div class="clear-both h-5"></div>

            <div class="s20 gap-6 px-4 pb-6 collapse-content active">
                <!--Frontoffice-->
                <!-- <div class="s13 flex gap-3 mb-5">
                    <span class="btn light">Janvier</span>
                    <span class="btn light2">Decembre</span>
                    <span class="btn light2">Novembre</span>
                    <span class="btn light2">Octobre</span>
                    <span class="btn light2">Septembre</span>
                </div> -->
                <div class="s20 flex gap-3 mb-2">
                    <div class="form-field-split my-4">
                        <div class="form-field-floating reactive search sm">
                            <input type="text" class="form-input" id="filters_search" v-model="queryParams.search" placeholder="" @keyup.enter="doListTransactions">
                            <label for="date1">Référence de transaction</label>
                        </div>
                    </div>
                    <div class="form-field-split my-4">
                        <div class="form-field-floating reactive sm">
                            <input type="date" class="form-input" v-model="dateParams.dateInf" placeholder="" @change="onDateParamsChanged">
                            <label for="date1">Date &lt;=</label>
                        </div>
                        <hr class="hr sm" />
                        <div class="form-field-floating reactive sm">
                            <input type="date" class="form-input" v-model="dateParams.dateSup" placeholder="" @change="onDateParamsChanged">
                            <label for="date2">Date &gt;=</label>
                        </div>
                    </div>
                    <div class="form-field-split my-4">
                        <div class="form-field-floating reactive sm">
                            <input type="time" class="form-input" v-model="dateParams.heureInf" placeholder="" @change="onDateParamsChanged">
                            <label for="time1">Heure &lt;=</label>
                        </div>
                        <hr class="hr sm" />
                        <div class="form-field-floating reactive sm">
                            <input type="time" class="form-input" v-model="dateParams.heureSup" placeholder="" @change="onDateParamsChanged">
                            <label for="time1">Heure &gt;=</label>
                        </div>
                    </div>
                </div>
                <div class="s20 flex gap-3 mb-5">
                    <span class="btn" :class="{'light': queryParams.banque_id == null, 'light2': queryParams.banque_id != null}">Tout</span>
                    <span class="btn" :class="{'light': queryParams.banque_id == item.banque.id, 'light2': queryParams.banque_id != item.banque.id}" v-for="(item, index) of user.cartes" :key="index" @click="onSelectBanque(item.banque.id)">{{ item.banque.nom }}</span>
                </div> 

                <div class="s8">
                    
                    <template v-if="itemsList.length > 0">
                        <!--Transaction - Component-->
                        <div class="flex gap-6 mb-4" v-for="(item, index) of itemsList" :key="index">
                            <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                                <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                            </div>
                            <div class="s13 mt-2">
                                <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                                <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                            </div>
                            <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                        </div>
                        <!--End Transaction-->

                        <!--Pagination-->
                        <custom-pagination v-model="queryParams.pageNumber" :total="pagination.total" :per-page="pagination.per_page" :last_page="pagination.last_page" @update:modelValue="onPaginate" />
                        <!---->
                    </template>
                    
                    <template v-if="itemsList.length == 0">
                        <div class="text-center">
                            <h6 class="secondary-font font-semibold mb-1">Aucune transaction enregistrée</h6>
                        </div>
                    </template>
                </div>

                <div class="s2 flex-center"><hr class="hr-vertical h-500" /></div>

                <div class="s10 px-4 mt-2">
                    <div class="s10">
                        <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                            <div class="circle-medium bg-color-1000"></div>
                            Décaissement
                        </h5>
                        <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">184 350 F</h1>
                        <h5 class="secondary-font font-semibold text-grey-700 mb-4">+5.4%</h5>
                    </div>
                    <div class="s10">
                        <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                            <div class="circle-medium bg-purple"></div>
                            Utilisation
                        </h5>
                        <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">52 350 F</h1>
                        <h5 class="secondary-font font-semibold text-grey-700 mb-4">56.4%</h5>
                    </div>

                    <div class="clear-both h-30"></div>

                    <img src="/images/graph-transaction.png" alt="Transaction Graph" width="100%" />
                </div>
            </div>

        </div>


        <div class="clear-both h-80"></div>

    </section>
</template>